<template>
  <div class="made-by-component text--center pb-3">
    <span>
        ©{{(new Date).getFullYear()}}.
        <a href="https://www.ibero.edu.co/" target="_blank" class="linkIbero">Universidad Iberoamericana</a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'made-by',
}
</script>

<style lang="scss">
.made-by-component {
  width: 100%;
  position: absolute;
  bottom: 0;
  color: #222;
}

a {
  text-decoration: none;
  color: #ffffff;
}

a:visited {
  text-decoration: none;
  color: #ffffff;
}

a:hover {
  text-decoration: underline;
  color: #ffffff;
}

a:active {
  text-decoration: underline;
  color: #ffffff;
}
</style>
